import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, Address } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Account
})
export class AccountMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    legalName: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField({ hidden: true })
    primaryContactId;

    @MergeField({ hidden: true })
    primarySiteId: string;

    @MergeField()
    taxId: string

    @MergeField()
    street1: string;

    @MergeField()
    street2: string;

    @MergeField()
    suburb: string;

    @MergeField()
    county: string;

    @MergeField()
    state: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    country: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    primarySiteName: string;

    customFields: any;

    address: Address;
}

export const AccountMergeSchema = getSchema(AccountMergeData);

export const contactMergeDataFromAccount = (account: AccountMergeData) => {
    return {
        _id: account._id,
        name: account.name,
        phone: account.phone,
        mobile: null,
        email: account.email,
        legalName: account.legalName
    };
};